import React from "react"

const SchoolHomePage = () => {
  return <h1>School Home Page</h1>
}

export default SchoolHomePage
